import {event} from '../modules/event';
import {scriptonload} from '../modules/scriptonload';

class NavMonth {
	constructor(wrapper) {
		this._createElements(wrapper);
		this._sortYear();
		this._sortMonth();
		this._sortAnchor();
		this._addEvents();
		this._checkSticky();
        //this._scrollToAnchor(false, this.curAnchor); Убираем прокрутку при загрузке
        scriptonload('/static/js/vendors/stickyfill.min.js', function(){ Stickyfill.add(wrapper)});
	}
	
	_createElements(wrapper){
		this.wrapper = wrapper;
		this.strip = this.wrapper.querySelector('[data-NavMonth-strip]');
        this.topBtn = this.wrapper.querySelector('[data-navMonth-topBtn]');
		this.wrapperHeight = this.wrapper.getBoundingClientRect().height;
		this.footer = document.getElementById('footer');
		this.yearAllByAnchor = {}; //хэш всех годов по ссылке
		this.yearAllByYear = {};
		this.monthAllByAnchor = {};
		this.monthByYear = {}; //хэш первых месяцев в каждом году. Необходимо, чтобы двигать меню при изменении  года
		this.anchorAll = {}; // хэш всех якорных заголовков
		this.curAnchor; //активный на данный момент элемент
		this.curYear; //активный на данный момент год
		this.scrollDelay = 100;
		this.isChanging = false;
	}

	_sortYear(){
		var all = this.wrapper.querySelectorAll('[data-NavMonth-year]');
		for(var i= 0,j=all.length; i<j; i++){
			var anchor = all[i].getAttribute('data-NavMonth-year');
			var year = anchor.split('_')[1];

			//
			this.yearAllByAnchor[anchor] = all[i];
			this.yearAllByYear[year] = all[i];

            if(all[i].className.indexOf('g-active') !== -1) this.curYear = year;
		}
	}

	_sortMonth(){
		var all = this.wrapper.querySelectorAll('[data-NavMonth-month]');
		for(var i= 0,j=all.length; i<j; i++){

            var data = JSON.parse(all[i].getAttribute('data-NavMonth-month')),
			    anchor = data.anchor,
			    year = data.year;

			this.monthAllByAnchor[anchor] = all[i];

			if(year){
				this.monthByYear[year] =  all[i];
			}

            if(all[i].className.indexOf('g-active') !== -1) this.curAnchor = anchor;
		}
	}

	_sortAnchor(){
		var all = document.querySelectorAll('[data-NavMonth-anchor]');
		for(var i= 0,j=all.length; i<j; i++){
			var anchor = all[i].getAttribute('id');
			this.anchorAll[anchor] = all[i];
		}
	}

	_addEvents(){
		var self = this;
		event.add(window, 'scroll', function(e){self._changeCallback.call(self)});
		event.add(window, 'resize', function(e){self._changeCallback.call(self)});

        event.add(this.topBtn, 'click', function(e){
            e.preventDefault();
            /* TODO
             *
              *  координату x
              * */
            window.scrollTo(0,0);
        });

		for(var key in this.yearAllByAnchor){
			event.add(this.yearAllByAnchor[key], 'click', (function(key){return function(e){self._scrollToAnchor.call(self, e, key)}})(key));
		}

		for(var key in this.monthAllByAnchor){
			event.add(this.monthAllByAnchor[key], 'click', (function(key){return function(e){self._scrollToAnchor.call(self, e, key)}})(key));
		}
	}

	_changeCallback(){
		if (this.isChanging) return false;
		this.isChanging = true;
		var self = this;

		this._checkSticky();
		this._findActiveAnchor();

		try{
			requestAnimationFrame(function(){
				self.isChanging = false;
			});
		} catch(e){
			this.isChanging = false;
		}
	}

	_checkSticky(){
		var boxTop = this.wrapper.getBoundingClientRect().top,
			footerTop = this.footer.getBoundingClientRect().top,
			clientHeight = document.documentElement.clientHeight;

		if((boxTop <= APP.headerHeight) ){ /* && (footerTop > clientHeight) */
			if(this.wrapper.className.indexOf('js-sticky') === -1) this.wrapper.className = this.wrapper.className + ' js-sticky';
		}
		else if(this.wrapper.className.indexOf('js-sticky') !== -1) this.wrapper.className = this.wrapper.className.replace(/\s*js-sticky/, '');
	}

	_findActiveAnchor(){
		var point = this.wrapper.getBoundingClientRect().bottom;
		var delta = false;
		var curAnchor = this.curAnchor;

		for(var key in  this.anchorAll){
			var top = this.anchorAll[key].getBoundingClientRect().top;
			var newDelta = Math.abs(top - point);
			if(!delta || (newDelta < delta)){
				delta = newDelta;
				curAnchor = key;
			}
		}

		this._checkChangeMenu(curAnchor);
	}

	_checkChangeMenu(curAnchor){
		var year = curAnchor.split('_')[1];

		//смотрим поменялся ли якорь
		if(this.curAnchor !== curAnchor){
            //меняем месяц
            this.monthAllByAnchor[this.curAnchor].className = this.monthAllByAnchor[this.curAnchor].className.replace(/ g-active/, '');

			this.curAnchor = curAnchor;
			this.monthAllByAnchor[this.curAnchor].className = this.monthAllByAnchor[this.curAnchor].className.replace(/ g-active/, '') + ' g-active';
		}

		//смотрим поменялся ли год
		if(year !== this.curYear){
            this.yearAllByYear[this.curYear].className = this.yearAllByYear[this.curYear].className.replace(/ g-active/, '');
            this._changeStripPosition(year);

			this.curYear = year;
			this.yearAllByYear[this.curYear].className = this.yearAllByYear[this.curYear].className.replace(/ g-active/, '') + ' g-active';
		}
	}

	_changeStripPosition(year){
		this.strip.style.left = this.strip.getBoundingClientRect().left - this.monthByYear[year].getBoundingClientRect().left + 'px';
	}

	_scrollToAnchor(e, curAnchor){
		if(e) e.preventDefault();



		//if(this.curAnchor === curAnchor) return;

		var target = this.anchorAll[curAnchor];
		var top = target.getBoundingClientRect().top - this.wrapperHeight - 10 - APP.headerHeight;
		window.scrollBy(0, top);
	}
};

export {NavMonth};







































